import { Box, Typography } from '@mui/material'
import type { ReactNode } from 'react'

interface Props {
  id: string
  title: string
  helper?: string
  children: ReactNode
  /** Relative width among the cards in the wrap row. */
  flex?: number
  minWidth?: number
}

/** V7 row 27 (Architecture A): titled control card with v2-style helper line. */
export function ControlCard({ id, title, helper, children, flex = 1, minWidth = 280 }: Props) {
  return (
    <Box
      data-testid={`control-card-${id}`}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        p: 2,
        flex,
        minWidth,
        // v2-style titled section: subtle tint sets the cards off the page canvas.
        bgcolor: 'grey.50',
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
        {title}
      </Typography>
      {helper ? (
        <Typography
          data-testid="control-card-helper"
          variant="caption"
          color="text.secondary"
          sx={{ display: 'block', mb: 1.5 }}
        >
          {helper}
        </Typography>
      ) : null}
      {children}
    </Box>
  )
}
